function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "Google360_svg__20_b",
  cx: "12.911%",
  cy: "13.554%",
  r: "99.306%",
  fx: "12.911%",
  fy: "13.554%",
  gradientTransform: "scale(.9999 1)"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "Google360_svg__19_a",
  x1: "37.066%",
  x2: "57.409%",
  y1: "44.485%",
  y2: "83.951%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#BF360C",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#BF360C",
  stopOpacity: 0
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#4FC3F7",
  d: "M18.46 18.449a6.32 6.32 0 01-4.155 1.848c-.09 0-.202.011-.302.011-.09 0-.202 0-.303-.011a10.126 10.126 0 01-4.681-1.31 9.358 9.358 0 01-2.14-1.636 9.886 9.886 0 01-2.217-3.337c-1.154-2.834-.941-6.06.582-8.759a10.004 10.004 0 00-5.107 8.736c0 3.741 2.05 7.023 5.107 8.759a9.992 9.992 0 004.973 1.321c1.344 0 2.61-.268 3.786-.739a9.974 9.974 0 004.972-4.368 10.173 10.173 0 001.31-4.681 6.275 6.275 0 01-1.825 4.166z"
}), React.createElement("path", {
  fill: "#4285F4",
  d: "M21.076 3.094a10.072 10.072 0 00-14.257 0 10.44 10.44 0 00-1.635 2.139 10.12 10.12 0 00-.572 8.758A10 10 0 006.83 17.33a10.44 10.44 0 002.14 1.635 10.224 10.224 0 004.68 1.31 6.344 6.344 0 01-4.154-1.847 6.221 6.221 0 01-1.848-4.447v-.011c0-1.714.436-3.438 1.321-4.973.437-.773.975-1.5 1.635-2.139a9.886 9.886 0 013.338-2.218 10.108 10.108 0 018.77.583 9.47 9.47 0 00-1.636-2.128z"
}), React.createElement("path", {
  fill: "#1A237E",
  d: "M13.958 4.494A10 10 0 0010.62 6.71a10.44 10.44 0 00-1.635 2.14 9.89 9.89 0 00-1.322 4.961v.079a10.06 10.06 0 011.322-4.895c.437-.773.974-1.5 1.635-2.139a9.886 9.886 0 013.338-2.218 10.108 10.108 0 018.77.583 2.68 2.68 0 00-.146-.235 10.086 10.086 0 00-8.624-.493zM6.879 17.172a9.886 9.886 0 01-2.217-3.337 9.967 9.967 0 01-.74-3.764 10.035 10.035 0 00.74 3.92 10 10 0 002.217 3.338 10.44 10.44 0 002.14 1.635 10.224 10.224 0 004.681 1.31 6.19 6.19 0 01-1.949-.414 10.62 10.62 0 01-2.721-1.053 9.107 9.107 0 01-2.15-1.635z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#FFC107",
  d: "M24.9 6.868a10.44 10.44 0 00-2.139-1.635 10.108 10.108 0 00-8.77-.582 10 10 0 00-3.337 2.217 10.44 10.44 0 00-1.635 2.14 10.113 10.113 0 00-1.31 4.961c0-1.602.615-3.214 1.847-4.446a6.32 6.32 0 014.749-1.848c1.624.044 3.226.492 4.682 1.31.772.437 1.5.974 2.139 1.635a9.886 9.886 0 012.217 3.338 10.081 10.081 0 01-.582 8.758 9.358 9.358 0 002.14-1.635c3.93-3.886 3.93-10.282 0-14.213z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M7.652 14.148a6.32 6.32 0 006.003 6.306c.09 0 .202.011.303.011.09 0 .201 0 .302-.011a6.344 6.344 0 004.155-1.848 6.342 6.342 0 001.815-3.763c.011-.168.033-.359.033-.538a6.294 6.294 0 01-1.848 4.144 6.32 6.32 0 01-4.155 1.848c-.09 0-.201.011-.302.011-.09 0-.202 0-.303-.011A6.344 6.344 0 019.5 18.449c-1.21-1.21-1.814-2.789-1.848-4.38v.08c0-.012 0 0 0 0z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#BF360C",
  d: "M23.31 13.835a10 10 0 00-2.218-3.338 10.44 10.44 0 00-2.139-1.635 10.224 10.224 0 00-4.682-1.31A6.238 6.238 0 009.522 9.4a6.155 6.155 0 00-1.859 4.423v.09a6.2 6.2 0 011.848-4.38 6.32 6.32 0 014.75-1.847c1.623.045 3.225.493 4.68 1.31.774.437 1.502.975 2.14 1.635a9.886 9.886 0 012.218 3.338 9.954 9.954 0 01.728 3.763 10.054 10.054 0 00-.717-3.897zm1.59 7.123a10.291 10.291 0 01-2.027 1.557c-.045.078-.078.156-.123.235a9.358 9.358 0 002.139-1.635 10.01 10.01 0 002.946-7.213 9.875 9.875 0 01-2.935 7.056z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#1A237E",
  d: "M21.124 10.81a9.886 9.886 0 012.218 3.338c.482 1.21.728 2.487.728 3.764a10.232 10.232 0 00-.728-3.92 10 10 0 00-2.218-3.338 10.44 10.44 0 00-2.139-1.635 10.224 10.224 0 00-4.681-1.31 6.19 6.19 0 011.948.414c.941.224 1.86.571 2.722 1.053a9.34 9.34 0 012.15 1.635z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#FFF",
  d: "M24.9 6.868a10.44 10.44 0 00-2.139-1.635 9.358 9.358 0 00-1.635-2.14 10.072 10.072 0 00-14.258 0 10.44 10.44 0 00-1.635 2.14 10.08 10.08 0 00-5.085 8.758v.079A10.068 10.068 0 015.11 5.468a10.15 10.15 0 00-1.176 4.76 10.21 10.21 0 011.31-4.838c.437-.773.975-1.501 1.635-2.14a10.072 10.072 0 0114.258 0 9.91 9.91 0 011.5 1.927 10.076 10.076 0 00-8.634-.504 10 10 0 00-3.338 2.218A10.44 10.44 0 009.03 9.03a10.009 10.009 0 00-1.31 4.95c0-.201.01-.425.033-.627a10.137 10.137 0 011.288-4.189c.437-.773.974-1.5 1.635-2.139a9.886 9.886 0 013.338-2.218 10.108 10.108 0 018.77.583c.772.437 1.5.974 2.139 1.635a10 10 0 012.945 7.056A10.08 10.08 0 0024.9 6.868z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#000",
  d: "M23.36 13.989a10 10 0 00-2.218-3.338 10.44 10.44 0 00-2.14-1.635 10.224 10.224 0 00-4.68-1.31 6.238 6.238 0 014.154 1.848 6.32 6.32 0 011.826 4.121c0 .112.011.202.011.314 0 .112 0 .202-.011.314a9.91 9.91 0 01-1.31 4.681c-1.12 1.949-2.868 3.517-4.973 4.368-1.165.47-2.442.74-3.775.74-1.814 0-3.516-.493-4.972-1.322.436.773.974 1.5 1.635 2.139a10.072 10.072 0 0014.257 0 10.44 10.44 0 001.636-2.14c1.5-2.698 1.69-5.946.56-8.78z"
}), React.createElement("path", {
  fill: "#3367D6",
  d: "M23.36 13.989a10 10 0 00-2.218-3.338 10.44 10.44 0 00-2.139-1.635 10.224 10.224 0 00-4.681-1.31 6.238 6.238 0 014.155 1.848 6.32 6.32 0 011.825 4.121c0 .112.012.202.012.314 0 .112 0 .202-.012.314a9.91 9.91 0 01-1.31 4.681c-1.12 1.949-2.867 3.517-4.973 4.368-1.165.47-2.441.74-3.785.74-1.815 0-3.517-.493-4.973-1.322.437.773.974 1.5 1.635 2.139a10.072 10.072 0 0014.258 0 10.44 10.44 0 001.635-2.14 10.249 10.249 0 00.571-8.78z"
}), React.createElement("path", {
  fill: "#1A237E",
  d: "M13.988 23.493a10.02 10.02 0 004.973-4.368 10.173 10.173 0 001.31-4.681c0-.112.011-.202.011-.314v-.078.235a9.91 9.91 0 01-1.31 4.681c-1.12 1.95-2.867 3.517-4.973 4.368-1.165.47-2.442.74-3.774.74-1.815 0-3.517-.493-4.973-1.322.045.078.09.157.145.235a10.1 10.1 0 004.85 1.243c1.3 0 2.576-.268 3.74-.739z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "#1A237E",
  d: "M5.367 22.827a10.1 10.1 0 004.85 1.243c1.344 0 2.61-.269 3.786-.739a9.974 9.974 0 004.972-4.368 10.173 10.173 0 001.31-4.682c0 .124-.01.247-.033.381a10.027 10.027 0 01-1.277 4.144 10.068 10.068 0 01-8.758 5.107c-1.814 0-3.517-.492-4.973-1.321a10.079 10.079 0 01-5.107-8.68v.078c0 3.752 2.05 7.023 5.107 8.759",
  opacity: 0.2
}), React.createElement("path", {
  fill: "url(#Google360_svg__19_a)",
  d: "M21.134 10.662c.941.964 1.658 2.084 2.128 3.248a10.081 10.081 0 01-.582 8.759 9.358 9.358 0 002.14-1.635 9.915 9.915 0 002.508-4.178l-6.194-6.194z",
  transform: "translate(.081 .081)"
}), React.createElement("path", {
  fill: "#1A237E",
  d: "M22.761 22.593a9.358 9.358 0 01-1.635 2.14 10.072 10.072 0 01-14.258 0 10.488 10.488 0 01-1.5-1.905c-.045-.033-.09-.045-.146-.078.437.773.974 1.5 1.635 2.139a10.072 10.072 0 0014.258 0 10.44 10.44 0 001.635-2.14 9.916 9.916 0 001.31-4.994 9.826 9.826 0 01-1.299 4.838z",
  opacity: 0.2
}), React.createElement("path", {
  fill: "url(#Google360_svg__20_b)",
  fillOpacity: 0.1,
  d: "M24.898 6.877a10.44 10.44 0 00-2.14-1.635 9.358 9.358 0 00-1.635-2.14 10.072 10.072 0 00-14.257 0 10.44 10.44 0 00-1.636 2.14A10.08 10.08 0 00.146 14c0 3.752 2.05 7.022 5.107 8.758.437.773.974 1.501 1.635 2.14a10.072 10.072 0 0014.258 0 10.44 10.44 0 001.635-2.14 9.358 9.358 0 002.139-1.635c3.92-3.931 3.92-10.326-.022-14.246zm-4.604 7.112a6.295 6.295 0 01-6.305 6.294 6.293 6.293 0 01-6.295-6.294c0-3.472 2.823-6.306 6.295-6.306s6.305 2.834 6.305 6.306z"
}));

var SvgGoogle360 = function SvgGoogle360(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _ref, _ref2);
};

export default SvgGoogle360;